import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('FactorFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getFactorList: function () {
            return $http.get(settings.ApiURL + settings.FactorURL);
        },
        getFactorById: function (id, code) {
            return $http.get(settings.ApiURL + settings.FactorURL + '/' + id + '/' + code);
        },
        saveFactor: function (factor) {
            return $http.put(settings.ApiURL + settings.FactorURL, factor);
        },
        deleteFactor: function (id, code) {
            return $http.delete(settings.ApiURL + settings.FactorURL + '/' + id + '/' + code);
        },
        getNewFactor: function () {
            return $http.get(settings.ApiURL + settings.FactorURL + "/newfactor");
        },
        getQuantityUnitDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/quantityunit/dropdown");
        }
    };
}]);

app.controller('FactorController', function ($q, $scope, FactorFactory, $rootScope, settings, masterFactory) {
    $rootScope.pageTitle = "Factor";    
    $scope.factors = [];
    $scope.factor = {};
    $scope.newfactor = {};
    $scope.error = "";
    $scope.modelState = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;
     $scope.factorQuantityUnits = [];

    // Initialization - this runs on load
    var init = function (pageIndex) {
        masterFactory.verifyAuthentication();

        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            FactorFactory.getFactorList().success(function (data) {
                $scope.factors = data;
                $scope.setFilterLists();
                $scope.refreshGrid(pageIndex);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            }),
            FactorFactory.getNewFactor().success(function (data) {
                $scope.newfactor = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            FactorFactory.getQuantityUnitDropdown().success(function (data) {
                $scope.factorQuantityUnits = data;
                //data.forEach(function (quantityUnit) {
                    
                //    if ($scope.factorQuantityUnits.length == 0 || !quantityUnitExits(quantityUnit))
                //        $scope.factorQuantityUnits.push(quantityUnit);
                //});
                $scope.refreshGrid(pageIndex);
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
        ]).then(function () {
        });
    };
    
    init(0);

    // Grid renderers
    $scope.refreshGrid = function (PageIndex) {                
        $('#gridFactor').dxDataGrid({
            dataSource: {
                store: {
                    data: $scope.factors,
                    type: 'array',
                    key: ["Id","Code"]
                }
            },            
            noDataText: "No Product Factors Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: PageIndex
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
                {
                    caption: 'Quantity Unit',
                    dataField: 'QuantityUnit',
                    cssClass: 'QuantityUnit',
                    dataType: 'string',
                    alignment: 'center',
                    lookup: {
                        dataSource: $scope.factorQuantityUnits                       
                    }                    
                },
                {
                    caption: 'Factor ID',
                    dataField: 'Id',
                    cssClass: 'Id',
                    dataType: 'number',
                    alignment: 'center',
                    lookup: {
                        dataSource: $scope.factorIds,
                        displayExpr: 'name',
                        valueExpr: 'value'
                    }
                },
                {
                    caption: 'Factor Code',
                    dataField: 'Code',
                    cssClass: 'Code',
                    dataType: 'number',
                    alignment: 'center',
                    lookup: {
                        dataSource: $scope.factorCodes,
                        displayExpr: 'name',
                        valueExpr: 'value'
                    }
                },
                {
                    caption: 'Temperature',
                    dataField: 'Temperature',
                    cssClass: 'Temperature',
                    dataType: 'number',
                    alignment: 'center',
                    cellTemplate: function (container, options) {
                        var text = options.data.Temperature;
                        if (options.data.Items.length > 1)
                            text = '....';
                        $('<span />').text(text).appendTo(container);
                    }
                },
                {
                    caption: 'Factor',
                    dataField: 'Value',
                    cssClass: 'Value',
                    dataType: 'number',
                    alignment: 'center',
                    cellTemplate: function (container, options) {
                        var text = options.data.Value;
                        if (options.data.Items.length > 1)
                            text = '....';
                        $('<span />').text(text).appendTo(container);
                    }
                }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $('#loadingModal').modal({ backdrop: 'static' });
                    FactorFactory.getFactorById(selectedRowsInfo.selectedRowsData[0].Id, selectedRowsInfo.selectedRowsData[0].Code).success(function (data) {
                        $scope.factor = data;
                        $scope.refreshFactorItems();
                        $scope.isFormVisible = true;
                        $scope.isDeleteVisible = true;
                        ToggleYellowToGreen();
                        $rootScope.pageTitle = "Factors";
                        $scope.error = "";
                        $scope.newUnit = "";
                        $scope.isNewUnit = false;
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                }
            }
        });
    };

    $scope.refreshFactorItems = function () {

        $('#gridFactorItems').dxDataGrid({
            dataSource: $scope.factor.Items,
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            height: 470,
            selection: { mode: 'single' },
            paging: {
                pageSize: 30
            },
            editing: {
                editEnabled: false,
                insertEnabled: true,
                removeEnabled: true
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: false
            },
            groupPanel: {
                visible: false,
            },
            columns: [
                {
                    caption: 'Temperature',
                    dataField: 'Temperature',
                    validationRules: [{ type: 'required' }],
                    alignment: 'center'
                },
                {
                    caption: 'Factor',
                    dataField: 'Value',
                    validationRules: [{ type: 'required' }],
                    alignment: 'center'
                }
            ],
            rowInserted: function (e) {
                var dataGrid = $('#gridFactorItems').dxDataGrid('instance');
                var index = $scope.factor.Items.length - 1;
                var flag = false;
                if ($scope.factor.Items[index].Temperature == undefined || $scope.factor.Items[index].Value == undefined || $scope.factor.Items[index].Temperature == '' || $scope.factor.Items[index].Value == '') {
                    $scope.factor.Items.splice(index, 1);
                    flag = true;
                }                

                dataGrid.refresh();
                if (!flag)
                    (dataGrid as unknown as FacnmDx).selectRows($scope.factor.Items[index]);
            }
        }).dxDataGrid('instance');

        var grd = document.getElementById("gridFactorItems");
        if (grd.getElementsByClassName("dx-datagrid-header-panel")[0].childNodes.length == 1)
            $('<span > Factor Items </span>').appendTo(grd.getElementsByClassName("dx-datagrid-header-panel")[0]);
    };

    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $scope.error = "";
        $rootScope.pageTitle = "New Factor";
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.factor = angular.copy($scope.newfactor);
        $scope.factor.Items = [];       
        $scope.refreshFactorItems();
        ToggleGreenToYellow();
        $scope.newUnit = "";
        $scope.isNewUnit = false;
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            FactorFactory.deleteFactor($scope.factor.Id, $scope.factor.Code).success(function (data) {
                FactorFactory.getFactorList().success(function (data) {
                    var dataGrid = $('#gridFactor').dxDataGrid('instance');                    
                    var pageindex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.factors = data;
                    $scope.setFilterLists();
                    $scope.cancelForm();
                    $scope.refreshGrid(pageindex);
                }).error(function () {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Factor successfully' });
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        $scope.error = "";
        var dataGrid = $('#gridFactor').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.factor = {};
        $scope.factor.Items = [];        
        $scope.isFormVisible = false;        
        $scope.factorForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.newUnit = "";
        $scope.isNewUnit = false;
    };

    $scope.reset = function (type) {
        if (type == 'update') { // get db bankaccount and set to scope.bankaccount. 
            $('#loadingModal').modal({ backdrop: 'static' });
            FactorFactory.getFactorById($scope.factor.Id, $scope.factor.Code).success(function (data) {
                $scope.factor = data;                
                $scope.refreshFactorItems();                                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });        
        }
        else {
            angular.copy($scope.newfactor, $scope.factor);
            $scope.refreshFactorItems();
        }   
        
        $scope.factorForm.$setPristine();
        $scope.factorForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.newUnit = "";
        $scope.isNewUnit = false;
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Factor details were reset' });        
    };

    $scope.submitForm = function () {
        if ($scope.factorForm.$valid) {
            $scope.saveFactor();
            $scope.factorForm.submitted = false;
        } else {
            $scope.factorForm.submitted = true;
        }
    };

    $scope.saveFactor = function () {
        $scope.error = "";      
        var pageindex, id;
        $scope.closeModelStateErrors();
        if ($scope.factor.Items.length > 0) {
            $('#loadingModal').modal({ backdrop: 'static' });
            FactorFactory.saveFactor($scope.factor).success(function (data) {
                FactorFactory.getFactorList().success(function (data) {
                    var dataGrid = $('#gridFactor').dxDataGrid('instance');
                    $scope.pageSize = dataGrid.pageSize();
                    pageindex = dataGrid.pageIndex();
                    $scope.factors = data;
                    $scope.setFilterLists();
                    if ($scope.factor.Id > 0) {
                        $scope.refreshGrid(pageindex)
                    }
                    else {
                        $scope.cancelForm();
                        $scope.refreshGrid(pageindex);
                    }                    
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function (data) {
                    if ($scope.factor.Id > 0) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Factor successfully' });
                    }
                    else {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Factor successfully' });
                    }
                });                                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        }
        else {
            $scope.error = 'Add minimum one Factor Item!';
        }        
    }

    // Adding and saving  new Quantity Unit
    $scope.addNewUnit = function () {
        $scope.isNewUnit = true;
        $scope.newUnit = "";
        masterFactory.setFocus('focusNewUnit');
    };

    $scope.saveNewUnit = function () {
        if ($scope.newUnit != "") {
            var flag = false;
            for (var i = 0; i < $scope.factorQuantityUnits.length; i++) {
                if ($scope.factorQuantityUnits[i].toLowerCase() == $scope.newUnit.toLowerCase()) {
                    flag = true;
                    $scope.newUnit = $scope.factorQuantityUnits[i];
                }
            }
            if (!flag) $scope.factorQuantityUnits.push($scope.newUnit);;
            $scope.factor.QuantityUnit = $scope.newUnit;
            $scope.isNewUnit = false;
        }
        else {
            masterFactory.setFocus('focusNewUnit');
        }
    };

    $scope.cancelNewUnit = function () {
        $scope.newUnit = "";
        $scope.isNewUnit = false;
    };
    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridFactor', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridFactor', settings.GridMarginHeight);
    };

    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };
    
    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    $scope.setFilterLists = function () {
        $scope.factorIds = [];
        $scope.factorCodes = [];       
        if ($scope.factors!= undefined && $scope.factors.length > 0) {
            $scope.factors.forEach(function (factor) {
                $scope.factorCodes.push({ name: factor.Code, value: factor.Code });
                $scope.factorIds.push({ name: factor.Id, value: factor.Id });
            });
            $scope.factors.forEach(function (factor) {
                if ($scope.factorQuantityUnits.length == 0 || !quantityUnitExits(factor.QuantityUnit))
                    $scope.factorQuantityUnits.push(factor.QuantityUnit);
            });
        }        
    };

    var quantityUnitExits = function (quantityUnit) {
        var flag = false;
        $scope.factorQuantityUnits.forEach(function (qUnit) {
            if (qUnit == quantityUnit) {
                flag = true;
            }
        });
        return flag;
    };

});